import { CdkTableModule } from '@angular/cdk/table';
import { NgModule } from '@angular/core';

import { NCellDefDirective, NCellDirective } from './cell.directive';
import { NColumnDefDirective } from './column-def.directive';
import { NFooterCellDefDirective, NFooterCellDirective } from './footer-cell.directive';
import { NFooterRowComponent, NFooterRowDefDirective } from './footer-row';
import { NHeaderCellDefDirective, NHeaderCellDirective } from './header-cell.directive';
import { NHeaderRowComponent, NHeaderRowDefDirective } from './header-row';
import { NNoDataRowDirective } from './no-data-row.directive';
import { NRowComponent, NRowDefDirective } from './row';
import { NTableComponent } from './table';

const components = [
  NCellDefDirective,
  NCellDirective,
  NColumnDefDirective,
  NFooterCellDefDirective,
  NFooterCellDirective,
  NFooterRowComponent,
  NFooterRowDefDirective,
  NHeaderCellDefDirective,
  NHeaderCellDirective,
  NHeaderRowComponent,
  NHeaderRowDefDirective,
  NNoDataRowDirective,
  NRowComponent,
  NRowDefDirective,
  NTableComponent,
];

@NgModule({
  declarations: components,
  exports: [components],
  imports: [CdkTableModule],
})
export class TableModule {}
